<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-row dense>
          <v-col
            v-for="skill in items"
            :key="skill.id"
            cols="12"
            sm="6"
            md="4"
            class="d-flex align-items-stretch"
          >
            <v-card variant="flat" class="my-4 flex-grow-1 app-content-card">
              <v-card-text class="text-left">
                <h3>{{ skill.Soft_skill }}</h3>
                <v-divider></v-divider>
              </v-card-text>
              <v-card-actions>
                <v-btn icon @click="openEditSoftSkillDialog(skill)">
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="error" @click="confirmDeleteSoftSkill(skill.id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-btn
          color="primary"
          @click="openAddSoftSkillDialog"
          class="mb-4 d-flex align-items-stretch"
        >
          {{ $t("candidateTabs.softSkills.addButton") }}
        </v-btn>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addSoftSkillDialog" max-width="600px">
      <v-card>
        <v-card-title>{{ $t("candidateTabs.softSkills.addTitle") }}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="addSoftSkill">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field :label="`${$t('candidateTabs.softSkills.field')} *`" v-model="newSoftSkill.Soft_skill" :rules="[rules.required]" outlined required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" type="submit">{{ $t("app.actions.add") }}</v-btn>
                  <v-btn variant="text" @click="closeAddSoftSkillDialog">{{ $t("app.actions.cancel") }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editSoftSkillDialog" max-width="600px">
      <v-card>
        <v-card-title>{{ $t("candidateTabs.softSkills.editTitle") }}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="updateSoftSkill">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field :label="`${$t('candidateTabs.softSkills.field')} *`" v-model="editSoftSkill.Soft_skill" :rules="[rules.required]" outlined required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" type="submit">{{ $t("app.actions.save") }}</v-btn>
                  <v-btn variant="text" @click="closeEditSoftSkillDialog">{{ $t("app.actions.cancel") }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";

// Soft Skills CRUD tab extracted from CandidateDetails.vue.
export default defineComponent({
  name: "CandidateSoftSkillsTab",
  props: {
    candidateId: { type: [String, Number], required: true },
    items: { type: Array, default: () => [] },
  },
  emits: ["refresh", "notify"],
  data() {
    return {
      addSoftSkillDialog: false,
      newSoftSkill: { Soft_skill: "" },
      editSoftSkillDialog: false,
      editSoftSkill: { id: null, Soft_skill: "" },
    };
  },
  computed: {
    rules() {
      return { required: (value) => !!value || this.$t("candidateTabs.common.requiredField") };
    },
  },
  methods: {
    openAddSoftSkillDialog() {
      this.newSoftSkill = { Soft_skill: "" };
      this.addSoftSkillDialog = true;
    },
    closeAddSoftSkillDialog() {
      this.addSoftSkillDialog = false;
    },
    addSoftSkill() {
      if (!this.newSoftSkill.Soft_skill.trim()) {
        this.$emit("notify", { message: this.$t("candidateTabs.softSkills.requiredEmpty"), color: "error" });
        return;
      }
      const payload = { id_foreign: this.candidateId, Soft_skill: this.newSoftSkill.Soft_skill };
      axios
        .post("/candidati/softskills", payload)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.softSkills.added"), color: "success" });
          this.addSoftSkillDialog = false;
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la adăugarea soft skill-ului:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.softSkills.addError"), color: "error" });
        });
    },
    openEditSoftSkillDialog(softSkill) {
      this.editSoftSkill = { ...softSkill };
      this.editSoftSkillDialog = true;
    },
    closeEditSoftSkillDialog() {
      this.editSoftSkillDialog = false;
    },
    updateSoftSkill() {
      if (!this.editSoftSkill.Soft_skill.trim()) {
        this.$emit("notify", { message: this.$t("candidateTabs.softSkills.requiredEmpty"), color: "error" });
        return;
      }
      const softSkillId = this.editSoftSkill.id;
      const payload = { id_foreign: this.candidateId, Soft_skill: this.editSoftSkill.Soft_skill };
      axios
        .put(`/candidati/softskills/${softSkillId}`, payload)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.softSkills.updated"), color: "success" });
          this.editSoftSkillDialog = false;
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la actualizarea soft skill-ului:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.softSkills.updateError"), color: "error" });
        });
    },
    confirmDeleteSoftSkill(id) {
      if (confirm(this.$t("candidateTabs.softSkills.deleteConfirm"))) {
        this.deleteSoftSkill(id);
      }
    },
    deleteSoftSkill(id) {
      axios
        .delete(`/candidati/softskills/${id}`)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.softSkills.deleted"), color: "success" });
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la ștergerea soft skill-ului:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.softSkills.deleteError"), color: "error" });
        });
    },
  },
});
</script>
